import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ThumbIconButton from '@wix/da-ds/pkg/thumbs/ThumbIconButton';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';

import { useIsCurrentUserDeviationAuthor } from '../../../../../utils/hooks/useIsCurrentUserDeviationAuthor';
import { useDeviationAttributes } from '../../../../hooks/useDeviationAttributes';
import FaveButton from '../../../../../FaveButton';
import FavingIcon from '../../../../../FaveButton/FavingIcon';

import s from './FaveControl.scss';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
  iconClassName?: string;
  textClassName?: string;
}

const FaveControl: React.FC<Props> = ({
  deviation,
  className,
  iconClassName,
  textClassName,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const isOwner = useIsCurrentUserDeviationAuthor(deviation);
  const { isFavouritable } = useDeviationAttributes(deviation, isOwner);

  const renderFaveButtonContent = ({ isFavourite, faveCount }) => {
    if (isMobile) {
      return (
        <ThumbIconButton
          isFakeButton
          type="fave"
          statValue={faveCount}
          isEngaged={isFavourite}
        />
      );
    } else {
      return (
        <>
          <FavingIcon
            className={iconClassName}
            deviationId={deviation.deviationId}
            isFavourited={isFavourite}
            size={IconSize.MEDIUM}
            withPadding={false}
            disableDefaultColors={true}
            aria-label={t('deviationview.overlay.a11y.favourite')}
          />
          <span className={textClassName}>
            {t(
              isFavourite
                ? 'actionbar.inFavourites'
                : 'actionbar.addToFavourites'
            )}
          </span>
        </>
      );
    }
  };

  return isFavouritable ? (
    <FaveButton
      className={classnames(s['root'], className)}
      deviation={deviation}
      aria-label={t('deviationview.overlay.a11y.favourite')}
    >
      {renderFaveButtonContent}
    </FaveButton>
  ) : null;
};
FaveControl.displayName = 'FaveControl';

export default FaveControl;
